/*
 * nav/actions
 *
 * Actions are the only way the app should interact with redux state.
 */
import uuidv4 from "uuid/v4";

import {
  CHECK_AUTH,
  CHECK_AUTH_FAILED,
  CHECK_CRBS_CONFIGURED_FAILED,
  CHECK_CRBS_CONFIGURED_START,
  CHECK_CRBS_CONFIGURED_SUCCESS,
  NOTIFICATION_CLEAR,
  NOTIFICATION_CREATE,
  NOTIFICATION_REMOVE} from "./constants";

const base = {};

base.checkCrbsConfigured = () => ({ type: CHECK_CRBS_CONFIGURED_START });
base.checkCrbsConfiguredSuccess = status => ({
  type: CHECK_CRBS_CONFIGURED_SUCCESS,
  status
});
base.checkCrbsConfiguredFailed = error => ({
  type: CHECK_CRBS_CONFIGURED_FAILED,
  error: {
    id: uuidv4(),
    message: error.message,
    description: "Unable to reach the RBAC server, please check configuration."
  }
});
base.checkAuth = () => ({
  type: CHECK_AUTH
});
base.checkAuthFailed = error => ({
  type: CHECK_AUTH_FAILED,
  error: {
    id: uuidv4(),
    message: error.message,
    description: "Checking user credentials failed."
  }
});

const notifications = {};

notifications.create = props => ({
  type: NOTIFICATION_CREATE,
  notification: {
    id: uuidv4(),
    ...props
  }
});
notifications.remove = id => ({
  type: NOTIFICATION_REMOVE,
  id
});
notifications.clear = () => ({
  type: NOTIFICATION_CLEAR
});

export { base, notifications };
